import { request as sonataRequest } from 'sonata-react-components';

import type { ScreenInventoryFilters, ScreenInventoryItem } from 'sonata-static-storage/lib/common/common.types';
import type { Token } from './common.types';

export async function getScreenInventoryFilters(token?: Token): Promise<ScreenInventoryFilters> {
  return sonataRequest.makeUnauthorizedRequest(
    `${taptap.config.backendUrlBase}screens/inventory-filters`,
    {
      method: 'GET'
    },
    token
  );
}

export async function getScreenInventory(token?: Token): Promise<ScreenInventoryItem[]> {
  return sonataRequest.makeUnauthorizedRequest(
    `${taptap.config.backendUrlBase}screens/inventory`,
    {
      method: 'POST'
    },
    token
  );
}
